import { Nullable } from 'src/types/nullable.type';
import create from 'zustand';
import { Block, BlockRenderElement, LayoutMode, Rect, RenderElement, Section, SectionGrid, Size } from '../types';
import produce from 'immer';
import {
  DEFAULT_PLAYER_LAYOUT_CONFIG,
  PlayerLayoutConfig,
  PlayerLayoutManager,
} from '../layout-manager/player-layout-manager';

type StateVars = {
  layout: {
    sections: Section[];
    sectionGrids: SectionGrid[];
    sectionRects: Rect[];
    renderElements: BlockRenderElement[];
    layoutReady: boolean;
    innerActualWidth: Nullable<number>;
    innerActualHeight: Nullable<number>;
    // layoutConfig: PlayerLayoutConfig;
  };
  innerAreaHeight: Nullable<number>;
  playerContentElement: Nullable<HTMLElement>;
  canvasScrollPosition: { x: number; y: number };
  sectionDrawerOpen: boolean;
};

type StateFns = {
  setLayoutMode: (layoutMode: LayoutMode) => void;
  setLayoutSizes: ({ width, height }: { width: number; height: number }) => void;
  setBlockContentSize: (blockId: Block['id'], size: Size) => void;
  setPlayerContentElement: (element: HTMLElement) => void;
  setCanvasScrollPosition: (x: number, y: number) => void;
  setSectionDrawerOpen: (open: boolean) => void;
  initEditor: (sections: Section[]) => void;
  resetEditor(): void;
};

type State = StateVars & StateFns;

function createInitialState(): StateVars {
  return {
    layout: {
      sections: [],
      sectionGrids: [],
      sectionRects: [],
      renderElements: [],
      layoutReady: false,
      innerActualWidth: null,
      innerActualHeight: null,
      // layoutConfig: DEFAULT_PLAYER_LAYOUT_CONFIG,
    },
    playerContentElement: null,
    innerAreaHeight: null,
    canvasScrollPosition: { x: 0, y: 0 },
    sectionDrawerOpen: false,
  };
}

const lm = new PlayerLayoutManager();
lm.addListener('update', () => {
  console.log('lm update');
  const { outputs } = lm;
  if (!outputs) {
    return;
  }
  console.log('lm update sections', lm.sections);
  usePlayerStore.setState(
    produce(usePlayerStore.getState(), (state) => {
      state.layout = {
        renderElements: lm.renderElements,
        sections: lm.sections,
        sectionGrids: lm.sectionGrids,
        sectionRects: outputs.sectionRects,
        layoutReady: true,
        innerActualWidth: outputs.innerActualWidth,
        innerActualHeight: outputs.innerActualHeight,
        // layoutConfig: lm.layoutConfig,
      };
    })
  );
});

export const usePlayerStore = create<State>((set, get) => ({
  ...createInitialState(),
  initEditor: (sections: Section[]) => {
    console.log('usePlayerStore', 'initEditor', sections);
    lm.initializeSections(sections);
  },
  resetEditor() {
    set(createInitialState());
    lm.reset();
  },
  setBlockContentSize: (blockId: string, size: Size) => {
    lm.setBlockContentSize(blockId, size);
  },
  setLayoutSizes: ({ width, height }: { width: number; height: number }) => {
    console.log('usePlayerStore', 'setLayoutSizes', width, height);
    lm.setLayoutInputs({
      innerAreaWidth: width,
      innerAreaHeight: height,
    });
    set({ innerAreaHeight: height });
  },
  setPlayerContentElement: (element: HTMLElement) => {
    set({ playerContentElement: element });
  },
  setCanvasScrollPosition: (x: number, y: number) => {
    set({ canvasScrollPosition: { x, y } });
  },
  setLayoutMode: (layoutMode: LayoutMode) => {
    lm.setLayoutMode(layoutMode);
  },
  setSectionDrawerOpen: (open: boolean) => {
    set({ sectionDrawerOpen: open });
  },
}));

// usePlayerStore.subscribe((state) => {
//   console.log('usePlayerStore changed', state);
// });

// @ts-ignore
window.playerStore = usePlayerStore;
